// removed by extract-text-webpack-plugin
module.exports = {"GeminiScrollbar":"G7Y8SQiYzBwsHP5OnfKXW_0","my-scroll-bar":"ODE9SZee86jS52EXmDIvr_0"};


// WEBPACK FOOTER //
// "}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8c1ffb6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main-content/vue-scrollbar.vue